/*
 * @Description: transferin
 * @Autor: dengyongliang
 * @Date: 2021-04-26 12:46:00
 * @LastEditors: dengyongliang
 * @LastEditTime: 2021-06-24 15:32:38
 */
'use strict'
import axios from '@/global/axios.js'
import * as action from '@/actions/transferin'

// 转入域名列表
export const TRANSFER_IN_LIST = (pageNum, pageSize, domainName, transferStatus, createTimeBegin, createTimeEnd) => {
  return axios({
    url: action.TRANSFER_IN_LIST,
    method: 'POST',
    data: { pageNum, pageSize, domainName, transferStatus, createTimeBegin, createTimeEnd }
  })
}
// 域名提交转入
export const SUBMIT_TRANSFER_IN = () => {
  return axios({
    url: action.SUBMIT_TRANSFER_IN,
    method: 'POST',
    data: {}
  })
}



// WEBPACK FOOTER //
// ./src/api/transferin.js